import { createSlice } from "@reduxjs/toolkit";

const cardPreviewSlice = createSlice({
    name: "cardPreview",
    initialState: {
        IsEcard: false,
        ShowCardGallery: false,
        HasMoreCards: false,
        OccasionLoading: false,
        OccasionLoaded: false,
        Occasion: {},
        CardIntention: '',
        CardSignature: '',
        EnvelopeRecipientAddress: '',
        EnvelopeReturnAddress: '',
        SelectedCard: {
            Id: 0,
            Description: '',
            InsideImage: '',
            CoverImage: '',
            PictureCode: '',
            EnvelopeBackgroundImage: ''
        }
    },
    reducers: {
        setOccasionLoading: (state, action) => {
            state.OccasionLoading = true;
            state.OccasionLoaded = false;
        },
        setSelectedOccasionState: (state, action) => {
            const selectedOccasion = action.payload;

            state.Occasion = selectedOccasion;

            state.SelectedCard.Id = selectedOccasion.DefaultCard.Id;
            state.SelectedCard.Description = selectedOccasion.DefaultCard.Description;
            state.SelectedCard.InsideImage = selectedOccasion.DefaultCard.InsideBackgroundImage;
            state.SelectedCard.CoverImage = selectedOccasion.DefaultCard.CoverImage;
            state.SelectedCard.EnvelopeBackgroundImage = selectedOccasion.DefaultCard.EnvelopeBackgroundImage;
            state.SelectedCard.PictureCode = selectedOccasion.DefaultCard.PortfolioPictureCode;

            state.OccasionLoading = false;
            state.OccasionLoaded = true;
        },
        setSelectedCard: (state, action) => {
            const selectedCard = action.payload;

            state.SelectedCard.Id = selectedCard.Id;
            state.SelectedCard.Description = selectedCard.Description;
            state.SelectedCard.InsideImage = selectedCard.InsideBackgroundImage;
            state.SelectedCard.CoverImage = selectedCard.CoverImage;
            state.SelectedCard.EnvelopeBackgroundImage = selectedCard.EnvelopeBackgroundImage;
            state.SelectedCard.PictureCode = selectedCard.PortfolioPictureCode;
        },
        setFieldFocus: (state, action) => {
            state.FocusedField = action.payload;
        },
        setFieldValue: (state, action) => {
            state[action.payload.key] = action.payload.value;
            //console.log(action.payload.key + ' | ' + action.payload.value);
        },
        setShowCardGallery: (state, action) => {
            state.ShowCardGallery = action.payload;
        },
        setEnvelopeRecipientAddress: (state, action) => {
            const values = action.payload;
            let recipientAddress = '';
            if(values.title) recipientAddress += values.title + ' ';
            recipientAddress += values.firstName + ' ' + values.lastName + '\n';
            recipientAddress += values.address1 + '\n';
            if(values.address2) recipientAddress += values.address2 + '\n';
            if(values.country === 'USA') {
                recipientAddress += values.city + ' ' + values.state + ' ' + values.postalCode;
            } else if(values.country === 'Canada') {
                recipientAddress += values.city + ' ' + values.province + ' ' + values.postalCode + '\n' + values.country;
            } else {
                recipientAddress += values.city + ' ' + values.postalCode + '\n' + values.country;
            }
            state.EnvelopeRecipientAddress = recipientAddress;
        },
        setEnvelopeReturnAddress: (state, action) => {
            const values = action.payload;
            let returnAddress = '';
            if(values.title) returnAddress += values.title + ' ';
            returnAddress += values.firstName + ' ' + values.lastName + '\n';
            returnAddress += values.address1 + '\n';
            if(values.address2) returnAddress += values.address2 + '\n';
            if(values.country === 'USA') {
                returnAddress += values.city + ' ' + values.state + ' ' + values.postalCode;
            } else if(values.country === 'Canada') {
                returnAddress += values.city + ' ' + values.province + ' ' + values.postalCode + '\n' + values.country;
            } else {
                returnAddress += values.city + ' ' + values.postalCode + '\n' + values.country;
            }
            state.EnvelopeReturnAddress = returnAddress;
        },
        clearEnvelopeReturnAddress: (state, action) => {
            state.EnvelopeReturnAddress = '';
        }
    }
});

export const cardPreviewActions = cardPreviewSlice.actions;

export default cardPreviewSlice;